<ul class="nav nav-tabs justify-content-start">
    <li class="nav-item">
      <a class="nav-link" routerLink="interfaceClientes" routerLinkActive="active">Clientes</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="interfaceDocumentosComerciales" routerLinkActive="active">Doc. Comerciales</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" routerLink="interfaceSAP" routerLinkActive="active">SAP</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" routerLink="interfaceStock" routerLinkActive="active">Stock</a>
    </li>
  </ul>
  <router-outlet></router-outlet>
